module.exports = __webpack_public_path__ + "img/1.f73f267.png";